export async function sleeper(sleepTime: number = 3000) {
  await new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true)
    }, sleepTime)
  })
  return true
}
